import { observer } from 'mobx-react';
import React from 'react';
import { setupEntityStore } from '../../../../../stores/setupEntityStore';
import { getFlagsObject } from '../../../../../../shared/utils/sortingAndGroupingUtil';
import { BILLING_TYPE } from '../../../../../../shared/constants/user-info/billingType';
import { SelfBillingPaymentStep } from '../SelfBillingPaymentStep/SelfBillingPaymentStep';
import { AutomatedBillingPaymentStep } from '../AutomatedBillingPaymentStep/AutomatedBillingPaymentStep';
import { ScanIqPaymentStep } from '../ScanIqPaymentStep/ScanIqPaymentStep';

/*
 * this container should contain only logic that payment step should be rendered
 */
const PaymentStep = observer(() => {
  const { billingType, solutionTypeFlags } = setupEntityStore;

  const billingTypeFlags = billingType
    ? getFlagsObject(BILLING_TYPE, [billingType])
    : null;

  const nutritionStep = billingTypeFlags?.SELF_BILLING ? (
    <SelfBillingPaymentStep />
  ) : (
    <AutomatedBillingPaymentStep />
  );

  // in case when selected both nutrition and scan_iq solutions, should be rendered nutrition step
  return solutionTypeFlags.NUTRITION ? nutritionStep : <ScanIqPaymentStep />;
});

export { PaymentStep };
